// system-page-access-tracker.ts
import { Injectable, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { SYSTEM_PAGE_KEY, clearSystemPageAccess } from './navigation-flag.guard';

@Injectable({ providedIn: 'root' })
export class SystemPageAccessTracker {
  private router = inject(Router);

  constructor() {
    // Cleared on NavigationStart rather than NavigationEnd: a navigation's
    // canActivate guards always run after its own NavigationStart, so the grant
    // can never be revoked between `allowSystemPageNavigation()` and the guard
    // that consumes it. On NavigationEnd a still-in-flight navigation to another
    // route could revoke the grant first and the user would be bounced to
    // /page-not-found instead of the intended system page.
    this.router.events
      .pipe(filter((e): e is NavigationStart => e instanceof NavigationStart))
      .subscribe((e) => {
        const allowedPath = sessionStorage.getItem(SYSTEM_PAGE_KEY);
        if (allowedPath && e.url.split('?')[0].split('#')[0] !== allowedPath) {
          clearSystemPageAccess();
        }
      });
  }
}
